<wiz-group width="100%" height="100%" padding="5px" class="section-container">
 

  <wiz-hgroup width="100%" height="100%" padding="10px">
    <form-widget
      #formWid
      code="widCode"
      pivotMode="false"
      showSetting="false"
      templatingMode="false"
      width="100%"
      height="100%"
    ></form-widget>
  </wiz-hgroup>

  <wiz-hgroup width="100%" horizontalAlign="end" style="padding-right: 20px;">
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>
</wiz-group>
